import * as View from "../../../src/Containers/ContractHistory/View.scss";
import { toString, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { bool_type, int32_type, getRecordElements, getRecordField, name as name_1, list_type, record_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import * as react from "react";
import { sortByDescending, mapIndexed, length, tryHead, fold as fold_1, empty, cons, ofArray, map, singleton, isEmpty } from "../../fable_modules/fable-library.3.7.20/List.js";
import { tryFind, ofList, toList } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { append, singleton as singleton_1, delay, toList as toList_1 } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { SimpleJson_tryParse } from "../../fable_modules/Fable.SimpleJson.3.21.0/SimpleJson.fs.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { Convert_fromJson } from "../../fable_modules/Fable.SimpleJson.3.21.0/Json.Converter.fs.js";
import { createTypeInfo } from "../../fable_modules/Fable.SimpleJson.3.21.0/TypeInfo.Converter.fs.js";
import { ValidatedUrlModule_value, UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { DateTimeExtensions_toDateHHmm, classNames, logii, DateTimeOffsetExtensions_toDateHHmm, getInitials, optToStr, stackClasses, DateTimeOffsetExtensions_toDateHHmmss, Locale$reflection, loge } from "../../Utils.js";
import { dotsLoading, getWrappedMaterialIcon } from "../../ViewUtils.js";
import { NumberHistoryDTO_SortByActiveFrom_285C6A16, NumberHistory_OfDTO, NumberHistory$reflection } from "../Subscriptions/Common.js";
import { LoadState$2, getTranslationFrom, LoadState$2$reflection } from "../../Global.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { warning, info, error } from "../../Components/Message/Message.js";
import { renderCell, renderHeader, renderCustomTable, Elements_renderCell, renderTable } from "../../Components/Table/Table.js";
import { now, toLocalTime } from "../../fable_modules/fable-library.3.7.20/DateOffset.js";
import { value as value_7, map as map_1, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { toString as toString_1 } from "../../fable_modules/fable-library.3.7.20/Long.js";
import { toString as toString_2 } from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import { Helpers_equalsButFunctions } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";
import { HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { fold } from "../../fable_modules/fable-library.3.7.20/Array.js";
import { NumberChange$reflection, DbFeeChangeContainer$reflection, ContractEvent$reflection, DbFeeChangeBeforeAfter$reflection } from "./Model.js";
import { union, ofList as ofList_1, toList as toList_2 } from "../../fable_modules/fable-library.3.7.20/Set.js";
import { uncurry, comparePrimitives } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { PageinationProps$1, Pagination } from "../../Components/Pagination/Pagination.js";
import { SimpleJson_tryParse as SimpleJson_tryParse_1 } from "../../fable_modules/Fable.SimpleJson.3.21.0/SimpleJson.fs.js";
import { modal } from "../../Components/Modal/Modal.js";
import { render as render_1 } from "../../Components/Modals/Choice/Choice.js";
import { compare } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { Contract$reflection } from "../Invoicee/Common.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_2 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { deleteLatestContractTypeChange as deleteLatestContractTypeChange_1, loadNumberHistory as loadNumberHistory_1, loadContractHistory as loadContractHistory_1, loadNumberChange, loadContractTypeChanges as loadContractTypeChanges_1 } from "./Api.js";
import { MessageType, renderAsModal } from "../../Components/Modals/InfoMessage/InfoMessage.js";


export class PdfDownloadDTO extends Record {
    constructor(DownloadedTemplate, File) {
        super();
        this.DownloadedTemplate = DownloadedTemplate;
        this.File = File;
    }
}

export function PdfDownloadDTO$reflection() {
    return record_type("Containers.ContractHistory.View.PdfDownloadDTO", [], PdfDownloadDTO, () => [["DownloadedTemplate", string_type], ["File", string_type]]);
}

function renderJsonString(getTranslation, clientNr, contractNr, jsonStr) {
    const jsonToHtml = (json) => {
        switch (json.tag) {
            case 2: {
                const children_7 = [toString(json.fields[0])];
                return react.createElement("span", {
                    className: "json__boolean",
                }, ...children_7);
            }
            case 0: {
                const children_9 = [json.fields[0].toString()];
                return react.createElement("span", {
                    className: "json__number",
                }, ...children_9);
            }
            case 1: {
                return react.createElement("span", {
                    className: "json__string",
                }, json.fields[0]);
            }
            case 3: {
                return react.createElement("span", {
                    className: "json__null",
                }, "-");
            }
            case 4: {
                const list_1 = json.fields[0];
                const children_15 = isEmpty(list_1) ? singleton("-") : map(jsonToHtml, list_1);
                return react.createElement("span", {
                    className: "json__array",
                }, ...children_15);
            }
            default: {
                const children_4 = map((tupledArg) => {
                    let children;
                    const children_2 = [(children = [tupledArg[0] + ": "], react.createElement("span", {
                        className: "json__string",
                    }, ...children)), jsonToHtml(tupledArg[1])];
                    return react.createElement("div", {}, ...children_2);
                }, toList(json.fields[0]));
                return react.createElement("div", {
                    className: "json__object",
                }, ...children_4);
            }
        }
    };
    const children_26 = toList_1(delay(() => {
        let children_24, children_20, children_22, children_18;
        const matchValue = SimpleJson_tryParse(jsonStr);
        if (matchValue != null) {
            const json_1 = matchValue;
            let matchValue_1;
            try {
                matchValue_1 = (new FSharpResult$2(0, Convert_fromJson(json_1, createTypeInfo(PdfDownloadDTO$reflection()))));
            }
            catch (ex) {
                matchValue_1 = (new FSharpResult$2(1, ex.message));
            }
            if (matchValue_1.tag === 1) {
                return singleton_1(jsonToHtml(json_1));
            }
            else {
                const dto = matchValue_1.fields[0];
                let downloadLink;
                const matchValue_2 = ValidatedUrlModule_create(new UrlKind(3, toText(printf("/Data/Mortgage/%i/%i/invoiceeFilesByContractNr/%s"))(clientNr)(contractNr)(dto.File)));
                if (matchValue_2.tag === 1) {
                    loge(toText(printf("[PdfDownloadDTO] Can\u0027t create url. Msg: %s"))(matchValue_2.fields[0]));
                    downloadLink = "";
                }
                else {
                    downloadLink = ValidatedUrlModule_value(matchValue_2.fields[0]);
                }
                return singleton_1((children_24 = [(children_20 = [toText(printf("\"%s\":"))(dto.DownloadedTemplate)], react.createElement("div", {}, ...children_20)), (children_22 = [getWrappedMaterialIcon("description")], react.createElement("a", {
                    href: downloadLink,
                    target: "_blank",
                    className: "invoice-table__download-pdf ml-2",
                }, ...children_22))], react.createElement("div", {
                    className: "d-flex",
                }, ...children_24)));
            }
        }
        else {
            return singleton_1((children_18 = [getTranslation("Common.NoData")], react.createElement("p", {
                ["data-translation"]: "Common.NoData",
            }, ...children_18)));
        }
    }));
    return react.createElement("div", {
        className: "history__json",
    }, ...children_26);
}

export class NumberHistoryProps extends Record {
    constructor(Locale, NumberHistoryLoadState) {
        super();
        this.Locale = Locale;
        this.NumberHistoryLoadState = NumberHistoryLoadState;
    }
}

export function NumberHistoryProps$reflection() {
    return record_type("Containers.ContractHistory.View.NumberHistoryProps", [], NumberHistoryProps, () => [["Locale", Locale$reflection()], ["NumberHistoryLoadState", LoadState$2$reflection(list_type(NumberHistory$reflection()), string_type)]]);
}

const renderNumberHistory = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const children_3 = toList_1(delay(() => {
        let children_1;
        const matchValue = props.NumberHistoryLoadState;
        switch (matchValue.tag) {
            case 1: {
                return singleton_1(dotsLoading);
            }
            case 3: {
                return singleton_1(error(matchValue.fields[0].split("")));
            }
            case 2: {
                return append(singleton_1((children_1 = [getTranslation("CustomerContract.Invoicee.Subscriptions.History.NumberHistory")], react.createElement("h3", {
                    className: "color-black mt-2",
                    ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.History.NumberHistory",
                }, ...children_1))), delay(() => singleton_1(renderTable(ofArray([getTranslation("Common.Number"), getTranslation("Common.ActiveFrom"), getTranslation("Common.ActiveTo"), "IMSI", "ICC"]), map((nh) => {
                    const renderDate = (date) => DateTimeOffsetExtensions_toDateHHmmss(props.Locale.ILocale, toLocalTime(date));
                    return ofArray([nh.NumberFrom, defaultArg(map_1(renderDate, nh.ActiveFrom), ""), defaultArg(map_1(renderDate, nh.ActiveTo), ""), defaultArg(map_1(toString_1, nh.Imsi), ""), defaultArg(map_1(toString_2, nh.Icc), "")]);
                }, matchValue.fields[0])))));
            }
            default: {
                return singleton_1(react.createElement(react.Fragment, {}));
            }
        }
    }));
    return react.createElement("div", {
        className: "history__number-history",
    }, ...children_3);
}, "NumberHistory", Helpers_equalsButFunctions, void 0, "renderNumberHistory", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\ContractHistory\\View.fs", 106);

function renderParsedFeeChange(feeChange) {
    let after, record_3, copyOfStruct_1, before, record_1, copyOfStruct, patternInput, set$_1, children_8, children_6;
    let tableHtml;
    const renderedRows = map((tupledArg) => {
        let props;
        const children_2 = cons((props = [new HTMLAttr(65, stackClasses(ofArray(["font-weight-bold", "cell"])))], react.createElement("td", keyValueList(props, 1), tupledArg[0])), map(Elements_renderCell, ofArray([toString(tupledArg[1]), toString(tupledArg[2])])));
        return react.createElement("tr", {}, ...children_2);
    }, (after = ((record_3 = feeChange.After, fold((acc_3, curr_1) => cons([name_1(curr_1), getRecordField(record_3, curr_1)], acc_3), empty(), getRecordElements((copyOfStruct_1 = record_3, DbFeeChangeBeforeAfter$reflection()))))), (before = ((record_1 = feeChange.Before, fold((acc_2, curr) => cons([name_1(curr), getRecordField(record_1, curr)], acc_2), empty(), getRecordElements((copyOfStruct = record_1, DbFeeChangeBeforeAfter$reflection()))))), (patternInput = [ofList(before), ofList(after)], fold_1((acc_1, key_1) => {
        const acc = acc_1;
        const v2 = tryFind(key_1, patternInput[1]);
        const key = key_1;
        const matchValue = [tryFind(key_1, patternInput[0]), v2];
        let pattern_matching_result, v1_5, v2_5, v1_6, v2_6, v1_7, v2_7, v1_8, v2_8;
        if (matchValue[0] == null) {
            if (matchValue[1] != null) {
                if (!(value_7(matchValue[1]) == null)) {
                    pattern_matching_result = 2;
                    v2_6 = value_7(matchValue[1]);
                }
                else {
                    pattern_matching_result = 5;
                }
            }
            else {
                pattern_matching_result = 5;
            }
        }
        else if (matchValue[1] == null) {
            if (!(value_7(matchValue[0]) == null)) {
                pattern_matching_result = 1;
                v1_6 = value_7(matchValue[0]);
            }
            else {
                pattern_matching_result = 5;
            }
        }
        else if (!((value_7(matchValue[0]) == null) ? true : (value_7(matchValue[1]) == null))) {
            pattern_matching_result = 0;
            v1_5 = value_7(matchValue[0]);
            v2_5 = value_7(matchValue[1]);
        }
        else if ((value_7(matchValue[0]) == null) && (!(value_7(matchValue[1]) == null))) {
            pattern_matching_result = 3;
            v1_7 = value_7(matchValue[0]);
            v2_7 = value_7(matchValue[1]);
        }
        else if ((!(value_7(matchValue[0]) == null)) && (value_7(matchValue[1]) == null)) {
            pattern_matching_result = 4;
            v1_8 = value_7(matchValue[0]);
            v2_8 = value_7(matchValue[1]);
        }
        else {
            pattern_matching_result = 5;
        }
        switch (pattern_matching_result) {
            case 0: {
                return cons([key, v1_5, v2_5], acc);
            }
            case 1: {
                return cons([key, v1_6, ""], acc);
            }
            case 2: {
                return cons([key, "", v2_6], acc);
            }
            case 3: {
                return cons([key, "", v2_7], acc);
            }
            case 4: {
                return cons([key, v1_8, ""], acc);
            }
            case 5: {
                return acc;
            }
        }
    }, empty(), toList_2((set$_1 = ofList_1(map((tuple) => tuple[0], before), {
        Compare: comparePrimitives,
    }), union(ofList_1(map((tuple_1) => tuple_1[0], after), {
        Compare: comparePrimitives,
    }), set$_1))))))));
    tableHtml = renderCustomTable(ofArray([renderHeader("Change"), renderHeader("Before"), renderHeader("After")]), renderedRows);
    const children_10 = [(children_8 = [react.createElement("span", {
        className: "font-weight-bold",
    }, "FeeNr: "), (children_6 = [optToStr(feeChange.FeeNr)], react.createElement("span", {}, ...children_6))], react.createElement("div", {
        className: "mb-2",
    }, ...children_8)), tableHtml];
    return react.createElement("div", {
        className: "history__contract-history",
    }, ...children_10);
}

class ContractHistoryInnerProps extends Record {
    constructor(Locale, ClientNr, ContractNr, History) {
        super();
        this.Locale = Locale;
        this.ClientNr = (ClientNr | 0);
        this.ContractNr = (ContractNr | 0);
        this.History = History;
    }
}

function ContractHistoryInnerProps$reflection() {
    return record_type("Containers.ContractHistory.View.ContractHistoryInnerProps", [], ContractHistoryInnerProps, () => [["Locale", Locale$reflection()], ["ClientNr", int32_type], ["ContractNr", int32_type], ["History", LoadState$2$reflection(list_type(ContractEvent$reflection()), string_type)]]);
}

const renderContractHistoryInner = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const children_20 = toList_1(delay(() => {
        let children;
        const matchValue = props.History;
        switch (matchValue.tag) {
            case 1: {
                return singleton_1(dotsLoading);
            }
            case 3: {
                return singleton_1(error(matchValue.fields[0].split("")));
            }
            case 2: {
                const changes = matchValue.fields[0];
                return append(singleton_1((children = [getTranslation("CustomerContract.Invoicee.Subscriptions.History.ContractEvent")], react.createElement("h3", {
                    className: "color-black mt-2",
                    ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.History.ContractEvent",
                }, ...children))), delay(() => (isEmpty(changes) ? singleton_1(info((getTranslation("CustomerContract.Invoicee.Subscriptions.History.NoContractEvent") + ".").split(""))) : singleton_1(Pagination()(new PageinationProps$1((items) => {
                    const children_18 = map((contractEvent) => {
                        let matchValue_1, children_6, children_14, props_13, children_12, props_9;
                        const name = contractEvent.Username;
                        const initials = getInitials(name);
                        const nameAndId = toText(printf("%s (%i)"))(name)(contractEvent.UserId);
                        const timestamp = DateTimeOffsetExtensions_toDateHHmm(props.Locale.ILocale, toLocalTime(contractEvent.AtUtc));
                        let dbFeeChangeContainerResult;
                        try {
                            dbFeeChangeContainerResult = (new FSharpResult$2(0, (matchValue_1 = SimpleJson_tryParse_1(contractEvent.EventArgs), (matchValue_1 != null) ? Convert_fromJson(matchValue_1, createTypeInfo(DbFeeChangeContainer$reflection())) : (() => {
                                throw (new Error("Couldn\u0027t parse the input JSON string because it seems to be invalid"));
                            })())));
                        }
                        catch (ex) {
                            dbFeeChangeContainerResult = (new FSharpResult$2(1, ex.message));
                        }
                        let renderedJsonHtml;
                        if (dbFeeChangeContainerResult.tag === 1) {
                            logii(toText(printf("[renderContractChangeItem] Attempted to parse content as JSON but couldn\u0027t, error message was: %s"))(dbFeeChangeContainerResult.fields[0]));
                            const children_2 = [renderJsonString(getTranslation, props.ClientNr, props.ContractNr, contractEvent.EventArgs)];
                            renderedJsonHtml = react.createElement("div", {
                                className: "contract-history-json-container",
                            }, ...children_2);
                        }
                        else {
                            renderedJsonHtml = renderParsedFeeChange(dbFeeChangeContainerResult.fields[0]);
                        }
                        const children_16 = [(children_6 = [react.createElement("div", {
                            className: "left__ball",
                            title: nameAndId,
                        }, initials)], react.createElement("div", {
                            className: "item__left",
                        }, ...children_6)), (children_14 = [(props_13 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "justify-content-between", "align-items-center"])))], (children_12 = [(props_9 = [new HTMLAttr(65, stackClasses(ofArray(["font-weight-bold", "mb-0"])))], react.createElement("h6", keyValueList(props_9, 1), contractEvent.EventName)), react.createElement("div", {
                            className: "right__timestamp",
                        }, timestamp)], react.createElement("div", keyValueList(props_13, 1), ...children_12))), renderedJsonHtml], react.createElement("div", {
                            className: "item__middle",
                        }, ...children_14))];
                        return react.createElement("li", {
                            className: "container__item",
                        }, ...children_16);
                    }, items);
                    return react.createElement("ol", {
                        className: "container__list overflow-auto color-black",
                        ["data-regression"]: "history-contract-list",
                    }, ...children_18);
                }, changes, 5, 0))))));
            }
            default: {
                return singleton_1(info((getTranslation("Common.WaitingToLoad") + "...").split("")));
            }
        }
    }));
    return react.createElement("div", {
        className: "history__container",
        id: "contract-history",
    }, ...children_20);
}, "ContractHistory", Helpers_equalsButFunctions, void 0, "renderContractHistoryInner", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\ContractHistory\\View.fs", 263);

const renderContractTypeChanges = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const isModalOpenState = react.useState(false);
    const children_23 = toList_1(delay(() => {
        let children_4, arg_3, arg_2;
        const matchValue = props.ContractTypeChangesLoadState;
        switch (matchValue.tag) {
            case 1: {
                return singleton_1(dotsLoading);
            }
            case 3: {
                return singleton_1(error(matchValue.fields[0].split("")));
            }
            case 2: {
                const changes = matchValue.fields[0];
                const offsetToString = (offset) => DateTimeOffsetExtensions_toDateHHmm(props.Locale.ILocale, toLocalTime(offset));
                let deleteContractTypeModalHtml;
                const header = (getTranslation("Common.Remove") + " ") + getTranslation("CustomerContract.Invoicee.Subscriptions.History.ContractTypeChanges");
                let bodyHtml;
                let areYouSureHtml;
                const children = [getTranslation("CustomerContract.Invoicee.Subscriptions.History.AreYouSure")];
                areYouSureHtml = react.createElement("div", {
                    className: "mt-3",
                }, ...children);
                let latestChangeHtml;
                const matchValue_1 = tryHead(changes);
                if (matchValue_1 == null) {
                    latestChangeHtml = react.createElement(react.Fragment, {});
                }
                else {
                    const change = matchValue_1;
                    const props_7 = [new HTMLAttr(65, stackClasses(ofArray(["p-2", "border", "fit-content"])))];
                    const children_6 = [react.createElement("span", {}, change.Display), (children_4 = [offsetToString(change.StartDate)], react.createElement("span", {
                        className: "ml-3",
                    }, ...children_4))];
                    latestChangeHtml = react.createElement("div", keyValueList(props_7, 1), ...children_6);
                }
                const noEffectOnFeesWarningHtml = warning(getTranslation("CustomerContract.Invoicee.Subscriptions.History.AreYouSure2").split(""));
                bodyHtml = react.createElement("div", {
                    className: "contract-type-change__modal-body",
                }, areYouSureHtml, latestChangeHtml, noEffectOnFeesWarningHtml);
                deleteContractTypeModalHtml = modal(isModalOpenState[0], render_1(header, bodyHtml, getTranslation("Common.Cancel"), getTranslation("Common.Remove"), (_arg) => {
                    isModalOpenState[1](false);
                }, (_arg_1) => {
                    isModalOpenState[1](false);
                    props.DeleteLatestContractTypeChangeFn();
                }));
                let headingHtml;
                const children_11 = [getTranslation("CustomerContract.Invoicee.Subscriptions.History.ContractTypeChanges")];
                headingHtml = react.createElement("h3", {
                    className: "color-black mt-2",
                    ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.History.ContractTypeChanges",
                }, ...children_11);
                let tableHtml;
                if (length(changes) <= 1) {
                    tableHtml = info((getTranslation("CustomerContract.Invoicee.Subscriptions.History.NoContractTypeChanges") + ".").split(""));
                }
                else {
                    const children_19 = [renderCustomTable(ofArray([renderHeader(getTranslation("CustomerContract.Invoicee.Subscriptions.History.ContractType")), renderHeader((arg_3 = getTranslation("Common.To"), (arg_2 = getTranslation("Common.From"), toText(printf("%s - %s"))(arg_2)(arg_3)))), renderHeader("")]), mapIndexed((index, change_1) => {
                        let matchValue_2, endDate, matchValue_3, endDate_1, arg_1, arg, children_13;
                        const rowClasses = classNames(ofArray([["gray", (matchValue_2 = change_1.EndDate, (matchValue_2 == null) ? false : ((endDate = matchValue_2, compare(now(), endDate) >= 0)))], ["font-weight-bold", (matchValue_3 = change_1.EndDate, (matchValue_3 == null) ? false : ((endDate_1 = matchValue_3, (compare(now(), change_1.StartDate) >= 0) && (compare(now(), endDate_1) <= 0))))]]));
                        const pastChangeCellHtml = renderCell(change_1.Display);
                        const fromToCellHtml = renderCell((arg_1 = defaultArg(map_1(offsetToString, change_1.EndDate), getTranslation("CustomerContract.Invoicee.Subscriptions.History.UntilFurtherNotice")), (arg = offsetToString(change_1.StartDate), toText(printf("%s - %s"))(arg)(arg_1))));
                        const buttonCellHtml = Elements_renderCell(((index === 0) && (compare(change_1.StartDate, now()) > 0)) ? ((children_13 = [getWrappedMaterialIcon("close")], react.createElement("span", {
                            className: "delete-button",
                            onClick: (_arg_2) => {
                                isModalOpenState[1](true);
                            },
                        }, ...children_13))) : react.createElement("span", {}));
                        return react.createElement("tr", {
                            className: rowClasses,
                        }, pastChangeCellHtml, fromToCellHtml, buttonCellHtml);
                    }, changes))];
                    tableHtml = react.createElement("div", {
                        className: "fit-content",
                        ["data-regression"]: "history-contract-type-changes-container",
                    }, ...children_19);
                }
                return singleton_1(react.createElement("div", {}, headingHtml, tableHtml, deleteContractTypeModalHtml));
            }
            default: {
                return singleton_1(info((getTranslation("Common.WaitingToLoad") + "...").split("")));
            }
        }
    }));
    return react.createElement("div", {
        className: "history__contract-type-change",
    }, ...children_23);
}, "ContractTypeChanges", Helpers_equalsButFunctions, void 0, "renderContractTypeChanges", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\ContractHistory\\View.fs", 411);

export class NumberChangesProps extends Record {
    constructor(Locale, ClientNr, ContractNr, NumberChangesLoadState) {
        super();
        this.Locale = Locale;
        this.ClientNr = (ClientNr | 0);
        this.ContractNr = (ContractNr | 0);
        this.NumberChangesLoadState = NumberChangesLoadState;
    }
}

export function NumberChangesProps$reflection() {
    return record_type("Containers.ContractHistory.View.NumberChangesProps", [], NumberChangesProps, () => [["Locale", Locale$reflection()], ["ClientNr", int32_type], ["ContractNr", int32_type], ["NumberChangesLoadState", LoadState$2$reflection(list_type(NumberChange$reflection()), string_type)]]);
}

const renderNumberChanges = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const children_22 = toList_1(delay(() => {
        let children;
        const matchValue = props.NumberChangesLoadState;
        switch (matchValue.tag) {
            case 1: {
                return singleton_1(dotsLoading);
            }
            case 3: {
                return singleton_1(error(matchValue.fields[0].split("")));
            }
            case 2: {
                const numberChanges = matchValue.fields[0];
                return append(singleton_1((children = [getTranslation("CustomerContract.Invoicee.Subscriptions.History.NumberChanges")], react.createElement("h3", {
                    className: "color-black mt-2",
                    ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.History.NumberChanges",
                }, ...children))), delay(() => {
                    let children_20;
                    return isEmpty(numberChanges) ? singleton_1(info((getTranslation("CustomerContract.Invoicee.Subscriptions.History.NoNumberChanges") + ".").split(""))) : singleton_1((children_20 = map((numberChange) => {
                        let children_4, children_14, props_11, children_10, children_12;
                        let name;
                        const _arg = numberChange.User.trim();
                        switch (_arg) {
                            case "unknown":
                            case "-1": {
                                name = "System";
                                break;
                            }
                            default: {
                                name = _arg;
                            }
                        }
                        const initials = getInitials(name);
                        const nameAndId = toText(printf("%s (%i)"))(name)(numberChange.UserId);
                        const timestamp = DateTimeExtensions_toDateHHmm(props.Locale.ILocale, numberChange.ChangeAtUtc);
                        const children_18 = [(children_4 = [react.createElement("div", {
                            className: "left__ball",
                            title: nameAndId,
                        }, initials)], react.createElement("div", {
                            className: "item__left",
                        }, ...children_4)), (children_14 = [(props_11 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "justify-content-between", "align-items-center"])))], (children_10 = [react.createElement("div", {
                            className: "color-black font-weight-bold",
                        }, numberChange.ChangeType), react.createElement("div", {
                            className: "right__timestamp",
                        }, timestamp)], react.createElement("div", keyValueList(props_11, 1), ...children_10))), (children_12 = [renderJsonString(getTranslation, props.ClientNr, props.ContractNr, numberChange.ParameterJson)], react.createElement("div", {
                            className: "color-black",
                        }, ...children_12))], react.createElement("div", {
                            className: "item__middle",
                        }, ...children_14)), react.createElement("div", {
                            className: "item__right",
                        })];
                        return react.createElement("li", {
                            className: "container__item",
                        }, ...children_18);
                    }, numberChanges), react.createElement("ol", {
                        className: "container__list",
                        ["data-regression"]: "history-number-changes-list",
                    }, ...children_20)));
                }));
            }
            default: {
                return singleton_1(info((getTranslation("Common.WaitingToLoad") + "...").split("")));
            }
        }
    }));
    return react.createElement("div", {
        className: "history__container",
        id: "number-changes-history",
    }, ...children_22);
}, "NumberChanges", Helpers_equalsButFunctions, void 0, "renderNumberChanges", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\ContractHistory\\View.fs", 492);

export class ContractHistoryProps extends Record {
    constructor(ClientNr, ContractNr, Locale, Contracts, ShouldRenderNumberChanges) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.ContractNr = (ContractNr | 0);
        this.Locale = Locale;
        this.Contracts = Contracts;
        this.ShouldRenderNumberChanges = ShouldRenderNumberChanges;
    }
}

export function ContractHistoryProps$reflection() {
    return record_type("Containers.ContractHistory.View.ContractHistoryProps", [], ContractHistoryProps, () => [["ClientNr", int32_type], ["ContractNr", int32_type], ["Locale", Locale$reflection()], ["Contracts", list_type(Contract$reflection())], ["ShouldRenderNumberChanges", bool_type]]);
}

export const renderContractHistory = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const numberChangeState = react.useState(new LoadState$2(0));
    const contractTypeChangeState = react.useState(new LoadState$2(0));
    const contractHistoryState = react.useState(new LoadState$2(0));
    const numberHistoryState = react.useState(new LoadState$2(0));
    const errorMessageState = react.useState(void 0);
    const loadContractTypeChanges = () => {
        contractTypeChangeState[1](new LoadState$2(1));
        startImmediate(singleton_2.Delay(() => singleton_2.Bind(loadContractTypeChanges_1(props.ClientNr, props.ContractNr), (_arg_1) => {
            const result_1 = _arg_1;
            const arg_4 = (result_1.tag === 1) ? (new LoadState$2(3, result_1.fields[0])) : (new LoadState$2(2, sortByDescending((change_1) => change_1.StartDate, result_1.fields[0], {
                Compare: compare,
            })));
            contractTypeChangeState[1](arg_4);
            return singleton_2.Zero();
        })));
    };
    react.useEffect(() => {
        numberChangeState[1](new LoadState$2(1));
        startImmediate(singleton_2.Delay(() => singleton_2.Bind(loadNumberChange(props.ClientNr, props.ContractNr), (_arg) => {
            const result = _arg;
            const arg_1 = (result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, sortByDescending((change) => change.ChangeAtUtc, result.fields[0], {
                Compare: compare,
            })));
            numberChangeState[1](arg_1);
            return singleton_2.Zero();
        })));
        loadContractTypeChanges();
        contractHistoryState[1](new LoadState$2(1));
        startImmediate(singleton_2.Delay(() => singleton_2.Bind(loadContractHistory_1(props.ClientNr, props.ContractNr), (_arg_2) => {
            const result_2 = _arg_2;
            const arg_7 = (result_2.tag === 1) ? (new LoadState$2(3, result_2.fields[0])) : (new LoadState$2(2, sortByDescending((change_2) => change_2.AtUtc, result_2.fields[0], {
                Compare: compare,
            })));
            contractHistoryState[1](arg_7);
            return singleton_2.Zero();
        })));
        numberHistoryState[1](new LoadState$2(1));
        startImmediate(singleton_2.Delay(() => singleton_2.Bind(loadNumberHistory_1(props.ClientNr, props.ContractNr), (_arg_3) => {
            const result_3 = _arg_3;
            const arg_13 = (result_3.tag === 1) ? (new LoadState$2(3, result_3.fields[0])) : (new LoadState$2(2, mapIndexed(NumberHistory_OfDTO, NumberHistoryDTO_SortByActiveFrom_285C6A16(result_3.fields[0]))));
            numberHistoryState[1](arg_13);
            return singleton_2.Zero();
        })));
    }, [props.ClientNr, props.ContractNr]);
    let contentHtml;
    let errorMessageHtml;
    const matchValue = errorMessageState[0];
    if (matchValue != null) {
        const msg_5 = matchValue;
        errorMessageHtml = renderAsModal("Error message", react.createElement("div", {}, msg_5), new MessageType(2), getTranslationFrom(translationsLoadState, "Common.Ok"), (_arg_5) => {
            errorMessageState[1](void 0);
        });
    }
    else {
        errorMessageHtml = react.createElement(react.Fragment, {});
    }
    const numberChangesHtml = props.ShouldRenderNumberChanges ? renderNumberChanges(new NumberChangesProps(props.Locale, props.ClientNr, props.ContractNr, numberChangeState[0])) : react.createElement(react.Fragment, {});
    const children_4 = [errorMessageHtml, renderContractTypeChanges({
        ContractTypeChangesLoadState: contractTypeChangeState[0],
        DeleteLatestContractTypeChangeFn: () => {
            startImmediate(singleton_2.Delay(() => singleton_2.Bind(deleteLatestContractTypeChange_1(props.ClientNr, props.ContractNr), (_arg_4) => {
                const result_4 = _arg_4;
                return singleton_2.Combine((result_4.tag === 1) ? ((errorMessageState[1](result_4.fields[0]), singleton_2.Zero())) : ((singleton_2.Zero())), singleton_2.Delay(() => {
                    loadContractTypeChanges();
                    return singleton_2.Zero();
                }));
            })));
        },
        Locale: props.Locale,
    }), renderNumberHistory(new NumberHistoryProps(props.Locale, numberHistoryState[0])), renderContractHistoryInner(new ContractHistoryInnerProps(props.Locale, props.ClientNr, props.ContractNr, contractHistoryState[0])), numberChangesHtml];
    contentHtml = react.createElement(react.Fragment, {}, ...children_4);
    return react.createElement("div", {
        className: "history",
        ["data-regression"]: "history-container",
    }, contentHtml);
}, void 0, uncurry(2, void 0), void 0, "renderContractHistory", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\ContractHistory\\View.fs", 651);

